/**
* Copyright Motili Inc., 2016 All Rights Reserved
*/

module.exports = {
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./WorkOrderScheduling'));
        });
    },
    childRoutes: [
        {
            path: '/m/contact/scheduling/:token',
            getComponent(nextState, callback) {
                require.ensure([], (require) => {
                    callback(null, require('./contact/ContactScheduling'));
                });
            }
        },
        {
            path: '/m/contractor/scheduled/:token',
            getComponent(nextState, callback) {
                require.ensure([], (require) => {
                    callback(null, require('./contractor/ContractorAcceptance'));
                });
            }
        },
        {
            path: '/m/contractor/accepted/:token',
            getComponent(nextState, callback) {
                require.ensure([], (require) => {
                    callback(null, require('./contractor/Accepted'));
                });
            }
        },
        {
            path: '/m/contractor/bulkscheduled/:token',
            getComponent(nextState, callback) {
                require.ensure([], (require) => {
                    callback(null, require('./contractor/BulkScheduledContainer'));
                });
            }
        }
    ]
};

// },
// {
// path: '/m/contact/scheduling/thankyou',
// getComponent(nextState, callback){
// require.ensure([], (require) => {
// callback(null, require('./ContactSchedulingThankYou'));
// });
// }
// },
// {
// path: '/m/contact/scheduling/accepted/:token',
// getComponent(nextState, callback){
// require.ensure([], (require) => {
// callback(null, require('./contact_required_scheduling/ContactSchedulingConfirmation'));
// });
// }
// },
// {
// path:'/m/contact/scheduling/emergency/:token',
// getComponent(nextState, callback){
// require.ensure([], (require) => {
// callback(null, require('./contact_required_scheduling/ContactSchedulingEmergency'));
// });
// }
// },
// {
// path: '/m/contractor/scheduled/:token',
// getComponent(nextState, callback){
// require.ensure([], (require) => {
// callback(null, require('./contractor_sms_scheduling/WorkOrderMobileScheduling'));
// });
// }
// },
// {
// path:'/m/contractor/scheduling/thankyou',
// getComponent(nextState, callback){
// require.ensure([], (require) => {
// callback(null, require('./ContractorSchedulingThankYou'));
// });
// }
// }
// ]
// };



// WEBPACK FOOTER //
// ./src/app/components/scheduling/route.WorkOrderScheduling.js